import ServicePage from './ServicePage';

const Bilan = () => <ServicePage serviceKey="assessment" />;

export default Bilan;
